import axios from "axios";
import config from "../config/config";
import { buildAuthHeaders, buildAuthRequestConfig } from "../utils/authSession";

function authHeaders() {
  return buildAuthHeaders();
}

async function get(url, options = {}) {
  const response = await axios.get(url, {
    ...buildAuthRequestConfig({
      ...options,
      headers: {
        ...(options.headers || {}),
        ...authHeaders(),
      },
    }),
  });
  return response.data;
}

async function post(url, body = {}, options = {}) {
  const response = await axios.post(url, body, {
    ...buildAuthRequestConfig({
      ...options,
      headers: {
        ...(options.headers || {}),
        ...authHeaders(),
      },
    }),
  });
  return response.data;
}

export async function getAdminTrustFraudCenter(params = {}) {
  return get(`${config.API_BASE_URL}/api/admin/trust-fraud`, { params });
}

export async function getAdminTrustFraudDeliverySummary() {
  return get(`${config.API_BASE_URL}/api/admin/trust-fraud/delivery-summary`);
}

export async function getAdminTrustFraudRecipients() {
  return get(`${config.API_BASE_URL}/api/admin/trust-fraud/recipients`);
}

export async function getAdminTrustSimulationControl() {
  return get(`${config.API_BASE_URL}/api/admin/trust-fraud/simulations`);
}

export async function getAdminTrustFraudEmployerDetail(userid) {
  return get(`${config.API_BASE_URL}/api/admin/trust-fraud/employers/${userid}`);
}

export async function acknowledgeAdminTrustFraudInbox() {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/inbox/acknowledge`, {});
}

export async function runAdminTrustFraudAction(userid, payload = {}) {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/employers/${userid}/actions`, payload);
}

export async function updateAdminTrustNotificationStatus(id, payload = {}) {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/notifications/${id}/status`, payload);
}

export async function saveAdminTrustFraudRecipient(payload = {}) {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/recipients`, payload);
}

export async function runAdminTrustSimulation(payload = {}) {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/simulations/run`, payload);
}

export async function cleanupAdminTrustSimulation(payload = {}) {
  return post(`${config.API_BASE_URL}/api/admin/trust-fraud/simulations/cleanup`, payload);
}
